"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle teaser
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.teaser = {};
exports.default = {};
